import { useRouter } from "next/router";
import React, { useEffect } from "react";
import withSnackbarRefProvider from "../../../common/components/notification/withSnackbarRefProvider";
import useJoinCourse from "../custom-hooks/useJoinCourse";

type THandleJoinCourse = React.FC<{
  enroll_url: string;
  user_enrolled: boolean;
}>;
const HandleJoinCourse: THandleJoinCourse = ({ enroll_url, user_enrolled }) => {
  const router = useRouter();

  const { handleJoinCourse } = useJoinCourse(enroll_url);

  useEffect(() => {
    // enroll user to course
    if (!user_enrolled && router.query?.enroll) {
      handleJoinCourse();
    }
  }, [handleJoinCourse, router.query?.enroll, user_enrolled]);

  return <></>;
};

export default withSnackbarRefProvider(HandleJoinCourse) as THandleJoinCourse;
